import { render, staticRenderFns } from "./zhuyuan_edit.vue?vue&type=template&id=282bdff0&scoped=true&"
import script from "./zhuyuan_edit.vue?vue&type=script&lang=js&"
export * from "./zhuyuan_edit.vue?vue&type=script&lang=js&"
import style0 from "./zhuyuan_edit.vue?vue&type=style&index=0&id=282bdff0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282bdff0",
  null
  
)

export default component.exports